import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=0013fa5e&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "styles/views/register/register.css?vue&type=style&index=0&id=0013fa5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0013fa5e",
  null
  
)

export default component.exports